<app-report [actionsConfig]="['filters']"
            [paramsConfig]="['metric', 'channel_not_required', 'new_period_without_comparison']"
            [disableComparison]="true"
            [enableDialogs]="true">
  <div actions></div>
  <mat-drawer-container class="full-height relative">
    <mat-drawer-content>
      <app-loader [enable]="loading$ | async">
        <div class="display-flex flex-column full-height">
          <app-jumbotron class="flex-grow">
            <app-transaction-id-report-table [requestParams]="requestParams$ | async"></app-transaction-id-report-table>
          </app-jumbotron>
          <app-conversion-path-legend class="mt-5"></app-conversion-path-legend>
        </div>
      </app-loader>
    </mat-drawer-content>
    <mat-drawer mode="over"
                style="width: 500px"
                position="end"
                [opened]="details$ | async"
                [autoFocus]="false"
                (closed)="details.onClose()">
      <app-transaction-id-report-details #details
                                         [row]="details$ | async"></app-transaction-id-report-details>
    </mat-drawer>
  </mat-drawer-container>
</app-report>
